
let initialState = ({
    weatherinfo: {
        name:"",
        main: {
            temp: "",
            humidity: "",
        },
        weather: [],
        wind: {
            speed: "",
        }
    }
})

 const WeatherReducer = (state = initialState, action) => {
    if(action.type === 'FETCH_WEATHER') {
        state = {
            ...state, weatherinfo: action.payload
        }
    }
    return state;
}
export default WeatherReducer